import { gql } from '@apollo/client';

const Lesson = gql`
  fragment Lesson on Lesson {
    id
    title
    alias
    description
    priority
    visible
    grammarTheme
    lessonProgress {
      id
    }
    images {
      path
      size
    }
  }
`;

export default {
  Lesson,
};
